import { getLimitDown, getDate, getDateDownLimitError, getDateUpLimitError, getMajorityLimit } from './dateUtils';
import React from 'react';
import { VALIDATION } from '@/constants/form';

export const isDateUnderLimit = (t, dateMin = getLimitDown()) => (dateToValidate) => {
  const date = getDate(dateToValidate);
  return (!date || date >= getDate(dateMin)) ||
    getDateDownLimitError(t('forms.errors.belowDateLimit'), dateMin);
};

export const isDateOverLimit = (t, dateMax = new Date()) => (dateToValidate) => {
  const date = getDate(dateToValidate);
  return (!date || date < getDate(dateMax)) ||
    getDateUpLimitError(t('forms.errors.aboveDateLimit'), dateMax);
};

// Allow chars included in "Basic Latin" & "Latin-1 Supplement" unicode blocks
// See https://en.wikipedia.org/wiki/List_of_Unicode_characters#Basic_Latin and https://en.wikipedia.org/wiki/List_of_Unicode_characters#Latin-1_Supplement
// eslint-disable-next-line no-control-regex
export const hasOnlyLatinChars = (text) => !/[^\u0020-\u00ff\u000D\u000A]/.test(text) || 'forms.errors.onlyLatinChars';

export const isValidSiret = (value) => VALIDATION.SIRET_REGEX.test(value) || 'forms.errors.invalidSiret';

export const isValidEmail = (value) => VALIDATION.EMAIL_REGEX.test(value) || 'error.emailNotValid';

export const hasOnlyNumbers = (value) => VALIDATION.ONLY_NUMBERS_REGEX.test(value) || 'forms.onlyNumbers';

export const hasOnlyNumbersOrDecimal = (value) => VALIDATION.ONLY_NUMBERS_OR_DECIMAL_REGEX.test(value) || 'forms.onlyNumbers';

export const hasNoNumbers = (value) => VALIDATION.NO_NUMBERS_REGEX.test(value) || 'forms.noNumbers';

export const getValidationClass = (name, { errors, isSubmitted }) => {
  if (!isSubmitted) {
    return;
  }

  return errors?.[name] ? 'is-invalid' : 'is-valid';
};

export const isAdult = (t, site) => (dateToValidate) => {
  const date = getDate(dateToValidate);

  return (!date || date < getMajorityLimit(site)) ||
    t('forms.errors.mustBeAdult');
};

const generateOptions = (list = []) => list?.map((o, i) =>
  <option disabled={o.value === ''} key={`${o.value}-${i}`} value={o.value}>
    {o.label}
  </option>
);

export const computeOptions = (options, favorites) => {
  if (favorites?.length) {
    const allOptions = [...favorites, { value: '', label: '' }, ...options];
    return generateOptions(allOptions);
  }
  return generateOptions(options);
};
